export default {
  branchOffices: [],
  selectedBranchOffice: null,
  loading: false,
}
